import React from "react";
import { FormSectionElements, FormSubSections } from "src/entities/formTemplateDataType";
import classNames from 'classnames';
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import { InputText } from "primereact/inputtext";
import validator from 'validator'
import Utils from "../../utilities/Utils";
import FormValidationUtils from "../../utilities/FormValidationUtils";
import { TextComponent } from "./TextComponent";
import { getRootComponent } from "../../utilities/ElementUtils";
import { ErrorMessage } from './AddressComponent';

interface Props {
  field: FormSectionElements;
  editable: boolean;
  title;
  labelControlArray;
  requiredField;
  callbackElement;
  isEng: boolean;
}

interface State {

}
export class EmailComponent extends TextComponent {


  constructor(props: Props) {
    super(props);
    this.props.field.IsDirty = false;
    FormValidationUtils.runInitJavascript(this.props.field);
    this.props.field.Visible = !this.props.field.InvisibleByDefault;
  }

  onBlur = (e: any) => {
    let field = this.props.field;
    field.Valid = true;
    FormValidationUtils.evalRegularExpression(field, 'gmi')
    if (!field.Valid) {
      field.ErrorMessage = "Blocked Email domain";
      field.ErrorMessageFRA = "fa- Blocked email domain";
    } else {
      FormValidationUtils.validateEmail(field);
    }
    if(field.Valid){
      FormValidationUtils.runJavascript(field);
    } 
    this.props.callbackElement(getRootComponent(this.props.field));
  }

  onTextEditChange = (e) => {
    let field = this.props.field;
    let val = e.target.value;
    field.Value = val;

    FormValidationUtils.runKeyStrokeJavascript(field);

    this.props.callbackElement(getRootComponent(this.props.field));
  }

}